/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popRefStat.vue?vue&type=template&id=2ecc6ef6&scoped=true"
import script from "./popRefStat.vue?vue&type=script&lang=js"
export * from "./popRefStat.vue?vue&type=script&lang=js"
import style0 from "./popRefStat.vue?vue&type=style&index=0&id=2ecc6ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc6ef6",
  null
  
)

export default component.exports